import { filterClasses } from "@swivl-mono/helpers";

import { useTicketingStore } from "../../../Models/Ticketing/Ticketing.Store";
import { TicketDetailPanel } from "./TicketDetailPanel";
import { TicketRightPanel } from "./TicketRightPanel";

interface TicketWorkspaceColumnsProps {
  /** Detail gets more than half the width. */
  favorDetail?: boolean;
}

// Detail + Tasks, shared by /inbox and the ticket-access page.
export function TicketWorkspaceColumns({ favorDetail }: TicketWorkspaceColumnsProps) {
  const hasSelection = useTicketingStore((s) => s.selectedTicketId !== null);

  return (
    <div className={filterClasses("grid h-full min-h-0 grid-cols-1 gap-3", favorDetail ? "lg:grid-cols-[3fr_2fr]" : "lg:grid-cols-2")}>
      <div className={filterClasses("min-h-0 overflow-hidden rounded-lg border border-grey-200 bg-white", !hasSelection && "hidden lg:block")}>
        <TicketDetailPanel />
      </div>
      <div className={filterClasses("min-h-0 overflow-hidden rounded-lg border border-grey-200 bg-white", !hasSelection && "hidden lg:block")}>
        <TicketRightPanel />
      </div>
    </div>
  );
}
